export const USER_ROLES_BLACKLIST = ['GLOBAL_ADMIN', 'GLOBAL_DEV', 'ACCOUNT_DEV'];

export const USER_PERMISSION_BLACKLIST = ['EDIT_ALL', 'VIEW_SCHEDULED_TAB', 'VIEW_MEETING_TAB'];
